import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';

import {
  TopBarContainer,
  SideNavContainer,
  AskingBidContainer,
  ItemNumberContainer,
  ItemNameContainer,
  PublicCommentsContainer,
  ItemDetailsContainer,
  BlockStatus,
} from 'components/project/FloorBidderScreen';


import { Layout } from './Styles';

export const NPALayoutSmall = observer(({ attrFlowDirection }) => {
  const {
    AuctionStore: {
      connected,
      auctionList,
      laneList,
      auctionID,
      auctionLaneName,
      auctionLaneId,
      getAuctionAndLaneTitle,
    },
    UIStore: { handleJoinAuction, handleJoinLane },
  } = useStores();

  return (
    <>
      <Helmet>
        <title>Floor Tote (Small)</title>
      </Helmet>
      <Layout>
        <TopBarContainer
          connected={connected}
          title={getAuctionAndLaneTitle}
          laneName={auctionLaneName}
          showLogo
          showLaunchPad
          showLogout={false}
        />
        <SideNavContainer
          auctionList={auctionList}
          currentAuctionId={auctionList && auctionID}
          laneList={laneList}
          currentLaneId={laneList && auctionLaneId}
          handleAuctionChange={(e) => handleJoinAuction(e.target.value)}
          handleLaneChange={(e) => handleJoinLane(e.target.value)}
        />
        <ItemNameContainer largerFont />
        <ItemNumberContainer />
        <AskingBidContainer />
        <BlockStatus />
        <PublicCommentsContainer />
        <ItemDetailsContainer flowDirection={attrFlowDirection} />
      </Layout>
    </>
  );
});

NPALayoutSmall.propTypes = {
  attrFlowDirection: PropTypes.string,
};

NPALayoutSmall.defaultProps = {
  attrFlowDirection: 'column',
};

export default NPALayoutSmall;
